import type { EbookGateway } from '@/application/port/out/EbookGateway';
import type { CreateEbookCommand, Ebook, ListEbooksParams, UpdateEbookCommand } from '@/domain/model/Ebook';

/** Casos de uso de Ebook (Material Didático PDF). */
export class ListEbooks {
  constructor(private readonly gateway: EbookGateway) {}
  execute(params: ListEbooksParams = {}): Promise<Ebook[]> { return this.gateway.list(params); }
}

export class CreateEbook {
  constructor(private readonly gateway: EbookGateway) {}
  execute(cmd: CreateEbookCommand): Promise<Ebook> { return this.gateway.create(cmd); }
}

export class UpdateEbook {
  constructor(private readonly gateway: EbookGateway) {}
  execute(id: string, cmd: UpdateEbookCommand): Promise<Ebook> { return this.gateway.update(id, cmd); }
}

export class ArquivarEbook {
  constructor(private readonly gateway: EbookGateway) {}
  execute(id: string): Promise<void> { return this.gateway.arquivar(id); }
}

export class BaixarEbook {
  constructor(private readonly gateway: EbookGateway) {}
  execute(id: string): Promise<Blob> { return this.gateway.baixar(id); }
}
